import React from "react";
import { FaPlus, FaTrash } from "react-icons/fa";

const DropdownMasterTab = ({
  dropdownTab,
  setDropdownTab,
  newProductCode,
  setNewProductCode,
  newSampleType,
  setNewSampleType,
  newCategory,
  setNewCategory,
  newSubCategory,
  setNewSubCategory,
  newProductType,
  setNewProductType,
  productCodeList,
  sampleTypeList,
  categoryList,
  subCategoryList,
  productTypeList,
  handleAddProductCode,
  handleDeleteProductCode,
  handleAddSampleType,
  handleDeleteSampleType,
  handleAddCategory,
  handleDeleteCategory,
  handleAddSubCategory,
  handleDeleteSubCategory,
  handleAddProductType,
  handleDeleteProductType,
}) => {
  const handleDropdownTabClick = (tab) => {
    setDropdownTab(tab);
  };

  return (
    <div className="dropdown-logs">
      <div className="dropdown-tabs" style={{ display: "flex" }}>
        <ul
          style={{
            display: "flex",
            justifyContent: "space-between",
            overflowX: "auto",
            width: "100%",
          }}
        >
          <li className={dropdownTab === "ProductCodes" ? "active" : ""}>
            <button
              onClick={() => handleDropdownTabClick("ProductCodes")}
              className={dropdownTab === "ProductCodes" ? "active" : ""}
            >
              Product Codes
            </button>
          </li>
          <li className={dropdownTab === "SampleTypes" ? "active" : ""}>
            <button
              onClick={() => handleDropdownTabClick("SampleTypes")}
              className={dropdownTab === "SampleTypes" ? "active" : ""}
            >
              Sample Types
            </button>
          </li>
          <li className={dropdownTab === "Categories" ? "active" : ""}>
            <button
              onClick={() => handleDropdownTabClick("Categories")}
              className={dropdownTab === "Categories" ? "active" : ""}
            >
              Categories
            </button>
          </li>
          <li className={dropdownTab === "SubCategories" ? "active" : ""}>
            <button
              onClick={() => handleDropdownTabClick("SubCategories")}
              className={dropdownTab === "SubCategories" ? "active" : ""}
            >
              Sub Categories
            </button>
          </li>
          <li className={dropdownTab === "ProductTypes" ? "active" : ""}>
            <button
              onClick={() => handleDropdownTabClick("ProductTypes")}
              className={dropdownTab === "ProductTypes" ? "active" : ""}
            >
              Product Types
            </button>
          </li>
        </ul>
      </div>

      {dropdownTab === "ProductCodes" && (
        <div className="product-codes-container">
          <div className="input-container">
            <input
              type="text"
              value={newProductCode}
              onChange={(e) => setNewProductCode(e.target.value)}
              placeholder="Add new Product Code"
            />
            <FaPlus onClick={handleAddProductCode} className="fa-plus" />
          </div>
          <div className="product-codes-table-container">
            <table className="product-codes-table">
              <thead>
                <tr>
                  <th>Product Code List</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {productCodeList.map((code, index) => (
                  <tr key={index}>
                    <td>{typeof code === 'object' ? code.product_code : code}</td>
                    <td>
                      <FaTrash
                        onClick={() => handleDeleteProductCode(code)}
                        className="fa-trash"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {dropdownTab === "SampleTypes" && (
        <div className="sample-types-container">
          <div className="input-container">
            <input
              type="text"
              value={newSampleType}
              onChange={(e) => setNewSampleType(e.target.value)}
              placeholder="Add new Sample Type"
            />
            <FaPlus onClick={handleAddSampleType} className="fa-plus" />
          </div>
          <div className="sample-types-table-container">
            <table className="sample-types-table">
              <thead>
                <tr>
                  <th>Sample Type List</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {sampleTypeList.map((type, index) => (
                  <tr key={index}>
                    <td>{typeof type === 'object' ? type.sample_type : type}</td>
                    <td>
                      <FaTrash
                        onClick={() => handleDeleteSampleType(type)}
                        className="fa-trash"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {dropdownTab === "Categories" && (
        <div className="sample-types-container">
          <div className="input-container">
            <input
              type="text"
              value={newCategory}
              onChange={(e) => setNewCategory(e.target.value)}
              placeholder="Add new Category"
            />
            <FaPlus onClick={handleAddCategory} className="fa-plus" />
          </div>
          <div className="sample-types-table-container">
            <table className="sample-types-table">
              <thead>
                <tr>
                  <th>Category List</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {categoryList.map((category, index) => (
                  <tr key={index}>
                    <td>{typeof category === 'object' ? category.category_name : category}</td>
                    <td>
                      <FaTrash
                        onClick={() => handleDeleteCategory(category)}
                        style={{
                          color: "red",
                          cursor: "pointer",
                          fontSize: "1.2em",
                          transition: "color 0.3s ease",
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {dropdownTab === "SubCategories" && (
        <div className="sample-types-container">
          <div className="input-container">
            <input
              type="text"
              value={newSubCategory}
              onChange={(e) => setNewSubCategory(e.target.value)}
              placeholder="Add new Sub Category"
            />
            <FaPlus onClick={handleAddSubCategory} className="fa-plus" />
          </div>
          <div className="sample-types-table-container">
            <table className="sample-types-table">
              <thead>
                <tr>
                  <th>Sub Category List</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {subCategoryList.map((subCategory, index) => (
                  <tr key={index}>
                    <td>{typeof subCategory === 'object' ? subCategory.subcategory_name : subCategory}</td>
                    <td>
                      <FaTrash
                        onClick={() => handleDeleteSubCategory(subCategory)}
                        className="fa-trash"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {dropdownTab === "ProductTypes" && (
        <div className="sample-types-container">
          <div className="input-container">
            <input
              type="text"
              value={newProductType}
              onChange={(e) => setNewProductType(e.target.value)}
              placeholder="Add new Product Type"
            />
            <FaPlus onClick={handleAddProductType} className="fa-plus" />
          </div>
          <div className="sample-types-table-container">
            <table className="sample-types-table">
              <thead>
                <tr>
                  <th>Product Type List</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {productTypeList.map((type, index) => (
                  <tr key={index}>
                    <td>{typeof type === 'object' ? type.product_type : type}</td>
                    <td>
                      <FaTrash
                        onClick={() => handleDeleteProductType(type)}
                        className="fa-trash"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownMasterTab;
